import type { QBOVendor } from '@/services/qbo'

/** Same normalization as DocumentPanel / Python ``normalize_vendor_name`` for QBO vendor matching. */
export function normalizeVendorNameForQboMatch(name: string): string {
  return name
    .replace(/\s*\[[^\]]*\]\s*/g, ' ')
    .replace(/\s+(co\.|inc\.|llc|ltd\.|corp\.|corporation|company)\s*$/i, '')
    .replace(/\./g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase()
}

/**
 * Best QBO ``display_name`` for an extracted/vendor string, or null if none of the
 * active vendors match (exact case-insensitive, normalized equality, or substring).
 */
export function findMatchingQboVendorDisplayName(
  extractedName: string | null | undefined,
  activeQboVendors: QBOVendor[],
): string | null {
  if (!extractedName) return null
  const trimmed = extractedName.trim()
  if (!trimmed) return null

  const exactMatch = activeQboVendors.find(
    (v) => v.display_name.toLowerCase() === trimmed.toLowerCase(),
  )
  if (exactMatch) return exactMatch.display_name

  const normalizedExtracted = normalizeVendorNameForQboMatch(trimmed)
  if (!normalizedExtracted) return null

  for (const vendor of activeQboVendors) {
    const normalizedVendor = normalizeVendorNameForQboMatch(vendor.display_name)
    if (normalizedExtracted === normalizedVendor) {
      return vendor.display_name
    }
    if (
      normalizedExtracted.includes(normalizedVendor) ||
      normalizedVendor.includes(normalizedExtracted)
    ) {
      return vendor.display_name
    }
  }

  return null
}

export function isDocVendorKnownInQbo(
  docVendorName: string | null | undefined,
  activeQboVendors: QBOVendor[],
): boolean {
  return findMatchingQboVendorDisplayName(docVendorName, activeQboVendors) != null
}
